export const environment = {
  production: true,
  buildId: '3532627416722491',
  configFile: 'config.json',
};
